import Pagination from 'js-pagination'
import _ from 'lodash';

export default class FilterBarSearch {
    constructor(el) {
        this.el = el;
        this.searchEl = this.el.querySelector('.filter-bar-search-input');
        this.taxonomyFilterEls = this.el.querySelectorAll('.spsx-taxonomy-filter');
        this.dateFilterEls = this.el.querySelectorAll('.spsx-date-filter');
        this.searchAction = this.el.dataset.action;
        this.searchType = this.el.dataset.type;
        this.resultsContainerEl = document.getElementById('filter-bar-results');
        this.searchEl.addEventListener('keyup', _.debounce(() => { this.handleFilteredSearch() },500));
        this.paginationEl = document.getElementById('pagination');
        this.resultsCountEl = document.getElementById('results-count');
        this.path = window.location.pathname

        if(this.resultsCountEl) {
            this.resultsCountEl.innerHTML = this.paginationEl.dataset.results;
        }

        if(this.paginationEl) {
            this.totalResults = this.paginationEl.dataset.results;
            this.ipp = this.paginationEl.dataset.ipp;
        }

        this.page = 1;

        for(const taxEl of this.taxonomyFilterEls) {
            taxEl.addEventListener('change', _.debounce(() => { this.handleFilteredSearch() },500));
        }

        for(const dateEl of this.dateFilterEls) {
            dateEl.addEventListener('change', _.debounce(() => { this.handleFilteredSearch() },500));
        }

        if(this.paginationEl) {
            if(window.innerWidth >= 768) {
                Pagination.config({
                    lang: 'en',
                    adjacent: 3
                });
            } else {
                Pagination.config({
                    lang: 'en',
                    adjacent: 1
                });
            }
            this.setupPagination();
        }

        if (this.path.includes('category')) {
            this.search(true)
        }
    }

    /**
     * Gets number of Posts while filtering
     */
    resultsCount() {
        if(this.resultsCountEl) {
            this.resultsCountEl.innerHTML = this.totalResults;
        }
    }

    /**
     * Gets values for any dropdown taxonomy filters in this filter bar
     */
    getTaxonomyFilters(filterData) {
        for(const el of this.taxonomyFilterEls) {
            if (el.value) {
                let filterName = el.name;
                filterData[filterName] = el.value;
            }
        }
        for(const el of this.dateFilterEls) {
            let filterName = el.name;
            filterData[filterName] = el.value;
        }
        return filterData;
    }

    getPathFilters(path, filterData) {
        let filterName = path[0]
        filterData[filterName] = path.slice(-1)[0]
        return filterData;
    }

    handleFilteredSearch() {
        this.search(true);
    }

    /**
     * Run search
     */
    search(setupPagination = false) {
        // Get Taxonomy filters
        let filterData = {};
        if (this.path.includes('category')) {
            let setupPagination = true
            let pathVars = this.path.split('/').filter(Boolean)
            filterData = this.getPathFilters(pathVars, filterData);
        }
        
        filterData = this.getTaxonomyFilters(filterData);

        // Add Action
        filterData.action = this.searchAction;

        // Search Query
        filterData.search_query_request = this.searchEl.value;

        // Type of search
        filterData.type = this.searchType;

        // Set Page
        filterData.selected_page = this.page;

        jQuery(this.resultsContainerEl)
            .empty()
            .html("<div class='please_wait'>Please wait...</div>");

        jQuery.ajax
        ({
            url         : SPSXCore.ajaxurl,
            //dataType    : "html",
            type        : "POST",
            dataType    : "json",
            data        : filterData,
            success: (data) => {
                jQuery(this.resultsContainerEl).html(data.html);
                this.totalResults = data.total;

                if(setupPagination) {
                    this.setupPagination();
                }
                this.resultsCount();
            }
        });
    }

    setupPagination() {
        this.pagination = {};
        this.paginationEl.innerHTML = '';
        this.paginationEl.innerHTML = '<div id="pagination-wrapper"></div>';
        this.pagination = new Pagination(this.totalResults, this.ipp, (page) => { this.pageSelect(page) }, '#pagination-wrapper');
    }

    pageSelect(page) {
        this.page = page.current;
        window.scroll({
            top: 0,
            left:0,
            behavior: 'smooth'
        });
        this.search(false);
    }
};